<nav class="header-navbar navbar navbar-expand-sm navbar-light bg-faded">
  <div class="container-fluid">
    <div class="navbar-header d-flex align-items-center d-lg-none justify-content-between">
      <button
        type="button"
        class="navbar-toggle d-none float-start"
        (click)="toggleSidebar()">
        <span class="visually-hidden">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <img
        mainLogo
        class="logo-farmportal d-none"
        [src]="logoUrl" />
      <span class="navbar-right navbar-collapse-toggle d-none">
        <a
          class="open-navbar-container"
          (click)="isCollapsed = !isCollapsed"
          role="button"
          [attr.aria-expanded]="!isCollapsed"
          aria-controls="navbarSupportedContent">
          <i class="ph ph-dots-three-vertical"></i>
        </a>
      </span>
    </div>
    <div class="navbar-container">
      <div
        class="collapse navbar-collapse d-block pb-0"
        id="navbarSupportedContent"
        [ngbCollapse]="isCollapsed">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</nav>
